import { useEffect, useState } from "react";
import moment from "moment";
import { colorAvatar } from "../../../components/SharedDoctorDetails/fakeData";
import { ReactComponent as WomanPatient } from "../../../assets/illustrations/calendar-svgrepo-com.svg";
import { ReactComponent as Time } from "../../../assets/illustrations/timer-svgrepo-com.svg";
import { ReactComponent as Location } from "../../../assets/illustrations/location-svgrepo-com.svg";
import Icon from "../../../components/Icon";
import alert from "../../../assets/images/alert.png";
import _ from "lodash";
import SelectComp from "../../../components/Select";
import { Formik } from "formik";
import validationSchema from "./validateSchema";
import { getAllClients } from "../../../api/client";
import Input from "../../../components/Input";
import { getAllExperts, getAllRequerants } from "../../../api/medecin";
import Select from "../../../components/Select";
import Button from "../../../components/ButtonUI";
import {
  addScreeningEvents,
  deleteScreeningEvents,
  getAllCampaigns,
  getAvailableMedecin,
  updateScreeningEvents,
} from "../../../api/screeningEvent";
import makeToast from "../../../components/Snackbar";
import { autocompleteAddress } from "../../../api/geoadresse";
import { IFeature, IGeocodeJsonResponse } from "../../../types/IGeocodeAdresse";

interface FormValues {
  campaignId: string;
  docReq: string;
  docExpert: string;
  eventDate: Date | null;
  lieu: string;
  numeroFacture: string;
  dateFacture: Date | null;
  tarif: number | null;
  nbJournees?: number;
}

interface Props {
  data: any;
  setShowAgendaModal: Function;
  day: any;
  onSuccess?: () => void;
}

const normalizeDoctor = (doc: any) => ({
  label: `${doc.firstName} ${doc.lastName}`,
  value: doc._id,
});

const DayPlan = (props: Props) => {
  const [campaignList, setCampaignList] = useState<any[]>([]);
  const [clientList, setClientList] = useState<any[]>([]);
  const [teleexpertList, setTeleexpertList] = useState<any[]>([]);
  const [requerantList, setRequerantList] = useState<any[]>([]);
  const [selectedDate, setSelectedDate] = useState<Date | null>(
    props.data?.eventDate ? new Date(props.data.eventDate) : null
  );
  const [allRequerants, setAllRequerants] = useState<any[]>([]);
  const [suggestions, setSuggestions] = useState<IFeature[]>([]);
  const [showErrors, setShowErrors] = useState(false);

  const title = props.data?._id
    ? "Modifier la journée de dépistage"
    : "Nouvelle journée de dépistage";
  
  const handlesubmitScreeningEvent = async (values) => {
    try {
      
      const response = await addScreeningEvents(values);
      const newScreeningEvent = response?.data;
      if (!newScreeningEvent) {
        makeToast("error", "Erreur lors de la creation de l'événement");
        return;
      }

      makeToast("success", "Événement créé avec succès.");
      props.onSuccess?.();
      props.setShowAgendaModal("");
    } catch (error) {
      makeToast("error", "Erreur lors de la création de l'événement");
    }
  };
  const handleEditScreeningEvent = async (values) => {
    try {
      const id = props.data._id;
      const response = await updateScreeningEvents(id, values);
      //console.log(response.updated_event)
      if (!response.updated_event) {
        makeToast("error", "Erreur lors de la modification de l'événement");
        return;
      }
      makeToast("success", "Événement modifié avec succès.");
      props.onSuccess?.();
      props.setShowAgendaModal("");
    } catch (error) {
      makeToast("error", "Erreur lors de la modification de l'événement");
    }
  };
  const handleDeleteScreeningEvent = async () => {
    try {
      const id = props.data._id;
      const response = await deleteScreeningEvents(id);
      if (response.message === "deleted") {
        makeToast("success", "Evènement supprimé avec succès.");
        props.onSuccess?.();
      } else {
        makeToast("error", "Erreur lors de la suppression de l'événement");
      }
      props.setShowAgendaModal("");
    } catch (error) {
      makeToast("error", "Erreur lors de la suppression de l'événement");
    }
  };

  const fetchCampaigns = async () => {
    const res = await getAllCampaigns();
    const list = Array.isArray(res) ? res : res.response || res.data || [];
    
    const options = list.map((c: any) => {
      const isFull = c.usedJournees >= c.nbJournees;

      return {
        value: c._id,
        label: isFull
          ? `${c.clientId?.name} — ${c.usedJournees}/${c.nbJournees} journées (Capacité atteinte)`
          : `${c.clientId?.name} — ${c.usedJournees}/${c.nbJournees} journées`,
        disabled: isFull
      };
    });
  
    setCampaignList(options);
  };

  useEffect(() => {
    fetchCampaigns();
  }, []);
  // get clients
  useEffect(() => {
    async function fetchMyAPI() {
      const res = await getAllClients();
      const list = Array.isArray(res) ? res : res.response || res.data || [];
      const options = list.map((client: any) => ({
        label: client.name,
        value: client._id,
      }));
      setClientList(options);
    }

    fetchMyAPI();
  }, []);

  // get all requerants
  useEffect(() => {
    const fetchAll = async () => {
      const res = await getAllRequerants();

      const opts = res.map((r: any) => ({
        label: `${r.firstName} ${r.lastName}`,
        baseLabel: `${r.firstName} ${r.lastName}`,
        value: r._id,
      }));

      setAllRequerants(opts);
    };

    fetchAll();
  }, []);

  //get available requerants
  useEffect(() => {
    if (!selectedDate || !allRequerants.length) {
      setRequerantList(allRequerants);
      return;
    }

    const fetchReq = async () => {
      const dateStr = moment(selectedDate).format("YYYY-MM-DD");
      const available = await getAvailableMedecin(dateStr);
      const availableIds = new Set(available.map((r: any) => r._id));

      const merged = allRequerants.map((r) => {
        const isAvailable = availableIds.has(r.value);

        return {
          ...r,
          disabled: !isAvailable,
          label: isAvailable ? r.baseLabel : `${r.baseLabel} (indisponible)`,
        };
      });

      setRequerantList(merged);
    };

    fetchReq();
  }, [selectedDate, allRequerants]);

  // get expert
  useEffect(() => {
    async function fetchAllExpertsAPI() {
      const listTeleExpert = await getAllExperts();
      setTeleexpertList(listTeleExpert);
      //console.log('listTeleExpert ',listTeleExpert)
    }
    fetchAllExpertsAPI();
  }, []);

  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-6 font-medium">
        <div className="w-full max-w-4xl h-full flex flex-col">
          <div className="block w-full rounded-3xl overflow-hidden text-left shadow-2xl bg-white flex-1 flex flex-col">
            <div
              className="flexCenter relative  text-white h-24  py-1"
              style={{ backgroundColor: "#4565f4" }}
            >
              {/* Close modal button */}
              <div className=" absolute right-0  top-0 rounded-bl-3xl border shadow-lg  cursor-pointer -mx-2 -my-2">
                <Icon
                  isIcon={true}
                  style={{ opacity: 0.5 }}
                  name="close"
                  onClick={() => {
                    props.setShowAgendaModal("");
                  }}
                />
              </div>
              <div className="">
                <span className="text-xl font-bold  leading-tight capitalize mx-2 w-2/3">
                  {title}
                </span>
              </div>
            </div>
            
            <div className="flex-1 overflow-y-auto p-6 bg-gray-50">
            
            <Formik<FormValues>
              enableReinitialize={true}
              initialValues={{
                campaignId: props.data?.campaignId?._id || "",
                docReq: props.data?.docReq || "",
                docExpert: props.data?.docExpert || "",
                eventDate: props.data?.eventDate
                  ? new Date(props.data.eventDate)
                  : null,
                lieu: props.data?.lieu || "",
                numeroFacture: props.data?.numeroFacture || "",
                dateFacture: props.data?.dateFacture
                  ? new Date(props.data.dateFacture)
                  : null,
                tarif: props.data?.tarif ?? null,
                nbJournees: props.data?.nbJournees ?? null,
              }}
              /*onSubmit={async (values) => {
                if (props.data?._id) {
                  console.log("hello")
                  console.log("EDIT PAYLOAD:", values);
                  await handleEditScreeningEvent(values);
                } else {
                  await handlesubmitScreeningEvent(values);
                }
              }}*/
              onSubmit={async (values) => {
                await handlesubmitScreeningEvent(values);
              }}
              validationSchema={validationSchema}
              //validateOnMount={false} // don't validate immediately
              validateOnChange={false} // validate as user types/selects
              validateOnBlur={true}
            >
              {(formik) => {
                const {
                  values,
                  errors,
                  handleChange,
                  handleBlur,
                  setFieldValue,
                  touched,
                  isSubmitting,
                  isValid,
                  handleSubmit,
                } = formik;

                return (
                  <form onSubmit={handleSubmit}>
                    
                    <div className="overflow-y-auto max-h-[75vh] bg-gray-50 py-8 rounded-b-3xl">
                      <div className="grid grid-cols-2 gap-4 px-8 mt-6">
                        {/* journée */}
                        <SelectComp
                          id="campaignId"
                          value={values.campaignId}
                          options={campaignList}
                          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                            const value = e.target.value;
                            setFieldValue("campaignId", value);
                            formik.setFieldTouched("campaignId", true, true);
                          }}
                          text="Sélectionner une campagne"
                          className="h-12 px-5 border border-gray-200"
                        />
                        {/* date */}
                        <div className="p-2 bg-white">
                          <label className="text-sm text-gray-400">Date</label>
                          <input
                            type="date"
                            onMouseDown={(e) => e.stopPropagation()}
  onClick={(e) => e.stopPropagation()}
                            value={
                              values.eventDate
                                ? moment(values.eventDate).format("YYYY-MM-DD")
                                : ""
                            }
                            onChange={(e) => {
                              const v = e.target.value;
                              console.log("Input string:", v);

                              if (!v) {
                                setFieldValue("eventDate", null);
                                setSelectedDate(null);
                                return;
                              }

                              if (v.length === 10) {
                                const parsedDate = new Date(v); 
                                parsedDate.setHours(4, 0, 0, 0); 
                                console.log("Safe Date Object:", parsedDate);

                                setFieldValue("eventDate", parsedDate);
                                setSelectedDate(parsedDate);
                              }
                            }}
                            onBlur={() =>
                              formik.setFieldTouched("eventDate", true)
                            }
                            className="custom-Input ml-5"
                          />
                        </div>
                      </div>
                      {/* Lieu */}
                      <div className="px-8 mt-4">
                        <Input
                          id="lieu"
                          placeholder="Lieu"
                          type="text"
                          error={touched.lieu ? errors.lieu : undefined}
                          onFocus={() => {
                            if (values.lieu && values.lieu.length >= 3) {
                              autocompleteAddress(values.lieu).then(
                                setSuggestions
                              );
                            }
                          }}
                          value={values.lieu}
                          onChange={async (e) => {
                            handleChange(e);
                            const value = e.target.value;
                            if (value.length >= 3) {
                              autocompleteAddress(value).then(setSuggestions);
                            } else {
                              setSuggestions([]);
                            }
                          }}
                          onBlur={(e) => {
                            handleBlur(e);
                            setTimeout(() => setSuggestions([]), 150);
                          }}
                          className="custom-Input mb-2.5 w-full rounded-xl"
                          inlineLabel={false}
                        />

                        {suggestions.length > 0 && (
                          <ul className="absolute z-10 w-auto bg-white border border-gray-200 rounded-md shadow">
                            {suggestions.map((feature) => (
                              <li
                                key={feature.properties.id}
                                className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                                onMouseDown={() => {
                                  setFieldValue(
                                    "lieu",
                                    feature.properties.label
                                  );
                                  //console.log(suggestions)
                                  setSuggestions([]);
                                }}
                              >
                                {feature.properties.label}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                      {/* Requérant  */}
                      <div className="grid grid-cols-2 gap-4 px-8 mt-6">
                        <div className="flex flex-col">
                          {props.data?._id && !values.docReq && (
                            <div className="flex items-center gap-1 mb-1 text-orange-600 animate-pulse">
                              <img src={alert} alt="warning" className="w-4 h-4 object-contain" />
                              <span className="text-xs font-bold">Requérant manquant</span>
                            </div>
                          )}
                        <SelectComp
                          id="docReq"
                          value={values.docReq}
                          options={requerantList}
                          onChange={(
                            e: React.ChangeEvent<HTMLSelectElement>
                          ) => {
                            const value = e.target.value;
                            setFieldValue("docReq", value);
                            formik.setFieldTouched("docReq", true, true);
                          }}
                          onBlur={() => formik.setFieldTouched("docReq", true)}
                          text="Sélectionner un requérant"
                          className=" flex-grow h-12 border border-gray-200 mb-2.5 rounded-xl"
                          //style={{ width: "417px" }}
                        />
                        </div>
                        {/* expert  */}
                        <div className="flex flex-col">
                          {props.data?._id && !values.docExpert && (
                            <div className="flex items-center gap-1 mb-1 text-orange-600 animate-pulse">
                              <img src={alert} alt="warning" className="w-4 h-4 object-contain" />
                              <span className="text-xs font-bold">Expert manquant</span>
                            </div>
                          )}
                        <Select
                          value={values.docExpert}
                          id="expertId"
                          text={"Sélectionner un expert"}
                          className="relative mb-2 rounded-xl"
                          options={teleexpertList?.map((e) => ({
                            value: e._id,
                            label: e.lastName + " " + e.firstName,
                          }))}
                          onChange={(
                            e: React.ChangeEvent<HTMLSelectElement>
                          ) => {
                            const value = e.target.value;
                            setFieldValue("docExpert", value);
                            formik.setFieldTouched("docExpert", true, true);
                          }}
                          //required={true}
                        ></Select>
                        </div>
                      </div>
                      {/* Tarif */}
                      <div className="grid grid-cols-2 gap-4 px-8 mt-4">
                        {/*<div>
                          <label className="text-sm text-black">Tarif €</label>
                          <Input
                            id="tarif"
                            placeholder="450"
                            type="number"
                            error={touched.tarif ? errors.tarif : undefined}
                            value={values.tarif ?? ""}
                            onChange={(e) => {
                              const v = e.target.value;
                              setFieldValue(
                                "tarif",
                                v === "" ? null : Number(v)
                              );
                            }}
                            onBlur={handleBlur}
                            className="custom-Input rounded-xl"
                          />
                        </div>*/}

                        {/*<div>
                          <label className="text-sm text-black">
                            Numéro de facture
                          </label>
                          <Input
                            id="numeroFacture"
                            placeholder="INV-2026-001"
                            type="text"
                            error={
                              touched.numeroFacture
                                ? errors.numeroFacture
                                : undefined
                            }
                            value={values.numeroFacture}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="custom-Input rounded-xl"
                          />
                        </div>*/}
                      </div>
                      {/* Date de facture */}
                      {/*<div className="px-8 mt-4">
                        <label className="text-sm text-gray-400">
                          Date de facture
                        </label>

                        <input
                          type="date"
                          onMouseDown={(e) => e.stopPropagation()}
                          onClick={(e) => e.stopPropagation()}
                          value={
                            values.dateFacture
                              ? moment(values.dateFacture).format("YYYY-MM-DD")
                              : ""
                          }
                          onChange={(e) => {
                            const date = e.target.value; // "YYYY-MM-DD"
                            setFieldValue(
                              "dateFacture",
                              moment(date, "YYYY-MM-DD").toDate()
                            );
                          }}
                          className="custom-Input mb-8 rounded-xl ml-5"
                        />
                        
                      </div>*/}
                      {showErrors &&
                        Object.entries(errors).map(([key, value]) => (
                          <div key={key} className="text-red-600 mb-1 flex px-8">
                            • {value}
                          </div>
                      ))}

                      <div className="flex justify-end gap-4 px-8 mt-6">
                        {props.data?._id && (
                          <Button
                            //status="secondary"
                            className="bg-red-600 px-6 py-3 rounded-xl text-lg font-medium"
                            onClick={async () => {
                              await handleDeleteScreeningEvent();
                            }}
                            //disabled={isSubmitting || !isValid}
                          >
                            Supprimer l'événement
                          </Button>
                        )}

                        <Button
                          status="secondary"
                          className="btn px-6 py-3 rounded-xl text-lg font-medium"
                          type="button"
                          onClick={() => {
                            props.setShowAgendaModal("");
                          }}
                        >
                          Annuler
                        </Button>

                        {!props.data?._id && (
                          <Button
                            status="primary"
                            className="btn px-6 py-3 rounded-xl text-lg font-medium"
                            type="submit"
                            disabled={isSubmitting || !isValid}
                            onClick={() => setShowErrors(true)}
                          >
                            Enregistrer
                          </Button>
                        )}

                        {/* UPDATE */}
                        {props.data?._id && (
                          <Button
                            status="primary"
                            className="btn px-6 py-3 rounded-xl text-lg font-medium"
                            type="button"
                            onClick={() =>
                              handleEditScreeningEvent(formik.values)
                            }
                          >
                            Mettre à jour
                          </Button>
                        )}
                      </div>
                    </div>
                    
                  </form>
                );
              }}
            </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default DayPlan;
